import React from 'react';
import './Footer.css';
import { FooterPropTypes } from '../utils/propTypes';

const year = new Date().getFullYear();

const Footer = ({isOpen}) => {
  return (
    <footer className={`cus-font py-md-3 footer ${isOpen ? 'open' : 'closed'}`}>
        <div className='f-bottom-block container-fluid d-flex flex-wrap justify-content-center align-self-center' style={{ rowGap: '15px' }}>
            <div className='f-bottom-left col-lg-7 col-md-12 col-sm-12 col-12 cus-font' style={{ rowGap: '8px', textAlign: 'center' }}>
                <a className='footer-link pe-4' href="https://www.themoodspace.com/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
                <a className='footer-link pe-4' href="https://www.themoodspace.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                <a className='footer-link pe-4' href="https://www.themoodspace.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                <a className='footer-link pe-4' href="https://www.themoodspace.com/disclaimer-policy" target="_blank" rel="noopener noreferrer">Disclaimer Policy</a>
            </div>
            <div className='col-lg-5 col-md-12 col-sm-12 col-12 cus-font' style={{ rowGap: '8px', textAlign: 'center' }}>
                © {year} The Mood Space All Rights Reserved
            </div>
        </div>
    </footer>

  );
};

Footer.propTypes = FooterPropTypes;

export default Footer;